import { MouseEvent } from "react";

// Show html tooltip when truncated with "..."
export const setTruncatedTitle = (event: MouseEvent<HTMLElement>) => {
    const element = event.currentTarget;
    element.title =
        Math.ceil(element.getBoundingClientRect().width) < element.scrollWidth
            ? element.textContent ?? ""
            : "";
};
